import { getApiEmails } from "./RemindMeAPIServices";

export const sendEmailImage = async (
  selectedEmail: string,
  imageInputs: string[],
  featureType: string,
  companyId: number,
  deviceId: string,
) => {
  try {
    const response = await fetch(getApiEmails('send-email-image'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        company_id: companyId,
        to_email: selectedEmail,
        feature_type: featureType,
        device_id: deviceId,
        // image: imageInputs.map((image, index) => ({
        //   data: image.split(',')[1],
        //   filename: `image${index + 1}.jpg`,
        //   mime: image.includes('png') ? 'image/png' : 'image/jpeg',
        // })),
        image: imageInputs.map((image, index) => {
          const [header, base64] = image.split(',');
          const mime = header.match(/:(.*?);/)?.[1] || 'image/jpeg';
          return {
            data: base64,
            filename: `image${index + 1}.jpg`,
            mime: mime,
          };
        }),
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to send email. Server responded with ${response.status}`);
    }

    const responseData = await response.json();
    return responseData;

  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};
